import { render, staticRenderFns } from "./InformasiKlaimPp.vue?vue&type=template&id=d9c84ffe&"
import script from "./InformasiKlaimPp.vue?vue&type=script&lang=js&"
export * from "./InformasiKlaimPp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports